import { useEffect, useState } from 'react'
import { MadfarmStaticSelect } from '../../ui/molecules/select/newSelect/static'
import { schedaCalcoloYearsOptions, ServiceTypeNormoptions, yearOptions } from '../../utils'
import { ButtonComponent } from '../../ui/molecules/button/newButton'
import { RoundedPlusIcon } from '../../ui/icons/RoundedPlusIcon'
import { ServiceTypeBox } from './components'
import { ServiceTypeCategoryEnum } from './dataService/dto'
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks'
import { BillingWorksheetCreation, BillingWorksheetUpdate, GetBillingWorksheetById, resetBWCreationRequest, resetBWCreationStatus, resetBWUpdateRequest, resetSTCreationRequest, setBWCreationNorm, setBWIdToUpdate, setBWUpdateCloneServiceTypesFromYear, setOnEdit, setSTCreationBillingWorksheetId } from './slice'
import { DocumentIcon } from '../../ui/icons/documentIcon'

export function SchedaCalcoloForms() {
    const dispatch = useAppDispatch()
    const serviceBillingState = useAppSelector(state => state.billingAndServiceType)
    const [normError, setNormError] = useState<boolean>(false)

    useEffect(() => {
        dispatch(resetSTCreationRequest())
        dispatch(resetBWCreationRequest())
        dispatch(resetBWUpdateRequest())
    }, [])

    useEffect(() => {
        if (serviceBillingState.billingWorksheetCreationStatus === 'successfully' &&
            serviceBillingState.billingWorksheetCreationResponse !== undefined
        ) {
            const bwId = serviceBillingState.billingWorksheetCreationResponse
            dispatch(setOnEdit(true))
            dispatch(setBWIdToUpdate(bwId))
        }
    }, [serviceBillingState.billingWorksheetCreationStatus])

    return (
        <div>
            <div className="m-6 mb-8 rounded-[20px] bg-[#F2F7F7]">
                <div className="bg-brandPrimary-600 px-6 py-4 rounded-t-[24px]">
                    <span className="text-white font-semibold text-xl">Scheda di Calcolo </span>
                    <span className="text-brandPrimary-300">/</span>
                    <span className="text-brandPrimary-100 font-semibold uppercase text-xl"> Inserimento</span>
                </div>

                <div className="px-6 py-5 flex flex-col gap-6">
                    <div className="flex flex-col gap-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <MadfarmStaticSelect
                                label="Normativa"
                                placeholder="Specifica normativa..."
                                noOptionsMessage="Nessuna normativa disponibile"
                                value={serviceBillingState.billingWorksheetCreationRequest.norm}
                                disabled={serviceBillingState.onEdit}
                                error={normError}
                                errorLabel="Normativa mancante"
                                options={ServiceTypeNormoptions}
                                onChange={(value) => {
                                    // @ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setBWCreationNorm(newValue))
                                }}
                            />
                            <MadfarmStaticSelect
                                label="Anno"
                                placeholder="Specifica anno..."
                                noOptionsMessage="Nessun anno disponibile"
                                disabled
                                options={yearOptions}
                                value={!serviceBillingState.onEdit ? String(new Date().getFullYear()) :
                                    String(serviceBillingState.billingWorksheetCreationRequest.year)
                                }
                            />
                        </div>

                        <div className="flex justify-end">
                            <ButtonComponent
                                disabled={serviceBillingState.onEdit}
                                variant="solid"
                                color="orange"
                                size="md"
                                iconPosition="left"
                                icon={<RoundedPlusIcon />}
                                label="Crea Scheda di Calcolo"
                                onClick={() => {
                                    setNormError(serviceBillingState.billingWorksheetCreationRequest.norm === undefined)
                                    if (!normError) {
                                        dispatch(BillingWorksheetCreation(serviceBillingState.billingWorksheetCreationRequest))
                                    }
                                }}
                            />
                        </div>
                    </div>

                    {
                        serviceBillingState.onEdit && (
                            <div className="flex flex-col gap-6">
                                <div className="border-t border-brandPrimary-600/40" />

                                <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-4 items-end">
                                    <MadfarmStaticSelect
                                        label="Copia Servizi dall'anno"
                                        placeholder="Specifica anno..."
                                        noOptionsMessage="Nessun anno disponibile"
                                        value={String(serviceBillingState.billingWorksheetUpdateRequest.yearToCloneServiceTypes)}
                                        options={schedaCalcoloYearsOptions}
                                        onChange={(value) => {
                                            // @ts-ignore
                                            const newValue = value !== null ? value.value : null
                                            dispatch(setBWUpdateCloneServiceTypesFromYear(Number(newValue)))
                                        }}
                                    />
                                    <ButtonComponent
                                        disabled={serviceBillingState.billingWorksheetUpdateRequest.yearToCloneServiceTypes === undefined}
                                        variant="outline"
                                        color="gray"
                                        size="md"
                                        iconPosition="left"
                                        icon={<DocumentIcon />}
                                        label="Copia"
                                        onClick={() => dispatch(BillingWorksheetUpdate({ body: serviceBillingState.billingWorksheetUpdateRequest, id: serviceBillingState.billingWorksheetIdToUpdate }))
                                        }
                                    />
                                </div>

                                <div className="flex flex-col gap-5">
                                    <ServiceTypeBox
                                        category={ServiceTypeCategoryEnum.SERVIZIO}
                                        billingWorksheetId={serviceBillingState.billingWorksheetIdToUpdate}
                                    />
                                    <ServiceTypeBox
                                        category={ServiceTypeCategoryEnum.SPESA_AGGIUNTIVA}
                                        billingWorksheetId={serviceBillingState.billingWorksheetIdToUpdate}
                                    />
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}